export default __webpack_public_path__ + "static/media/myb.b96a8806.svg";